import React from 'react'
import PropTypes from 'prop-types'

function DummyRenderer ({ config, presentationKey, blueprint }) {
  return (
    <div style={{
      background: 'var(--color-neutral-100)',
      border: '1px solid var(--color-neutral-300)',
      borderRadius: '8px',
      padding: '16px'
    }}
    >
      <div style={{ marginBottom: '8px', fontWeight: 600, color: 'var(--color-neutral-700)' }}>
        Smart Component: {blueprint?.name || 'Unknown'} / {presentationKey}
      </div>
      <pre style={{
        margin: 0,
        fontSize: '13px',
        overflow: 'auto',
        maxHeight: '400px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
      }}
      >
        {JSON.stringify(config, null, 2)}
      </pre>
    </div>
  )
}

DummyRenderer.propTypes = {
  config: PropTypes.object,
  presentationKey: PropTypes.string,
  blueprint: PropTypes.object
}

export default DummyRenderer
